import { render, staticRenderFns } from "./CommunicationConfig.vue?vue&type=template&id=d333a122&scoped=true&"
import script from "./CommunicationConfig.vue?vue&type=script&lang=js&"
export * from "./CommunicationConfig.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationConfig.vue?vue&type=style&index=0&id=d333a122&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d333a122",
  null
  
)

export default component.exports